import "./menu.scss"
import GitHubIcon from '@mui/icons-material/GitHub';

export default function Menu({menueOpen, setMenueOpen , theme , setTheme}) {

  return (
    <div className={ "menu " + ((menueOpen && "active ") || (theme && "dark"))}>Menu
    <ul >
        <li onClick={() => setMenueOpen(false)}>
        <a href="#intro"> Home </a>
        </li>
        
        <li onClick={() => setMenueOpen(false)}>
        <a href="#works"> Works </a>
        </li>
        
        <li onClick={() => setMenueOpen(false)}>
        <a href="#contacts"> Contact </a>
        </li>
      <li>
        <pre> <br /><br /> <GitHubIcon className="icon"/><a href="https://github.com/ananyajain10"> ananyajain10 </a></pre>
      
      </li>

    </ul>
    </div>
  )
}
